import { COLLECTIONS, type EntryLink } from '@/mocks/kanliao';

function Badge({ badge }: { badge: EntryLink['badge'] }) {
  if (!badge) return null;
  const map: Record<string, string> = {
    新: 'bg-primary-100 text-primary-800',
    热: 'bg-accent-100 text-accent-800',
    荐: 'bg-secondary-100 text-secondary-800',
  };
  return (
    <span className={`rounded-sm px-1 py-px text-[9px] font-bold ${map[badge] ?? map['荐']}`}>{badge}</span>
  );
}

export default function Collections() {
  return (
    <section id="collections" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        {/* section heading */}
        <div className="mb-7 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div className="flex items-end gap-4">
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              分类合集
            </h2>
            <span className="mb-1 hidden h-8 w-1 rounded-full bg-primary-500 sm:block" />
          </div>
          <p className="max-w-sm text-xs leading-5 text-foreground-500 sm:text-sm">
            六大合集按题材分区，索引醒目，想看哪类直接点进去挑入口。
          </p>
        </div>

        {/* index chip rail */}
        <div className="mb-6 flex flex-wrap gap-2">
          {COLLECTIONS.map((c) => (
            <a
              key={c.id}
              href={`#col-${c.id}`}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm text-foreground-800 ring-1 ring-background-200 transition-colors hover:bg-foreground-950 hover:text-background-50"
            >
              <span className="font-heading text-xs font-bold text-primary-600">{c.index}</span>
              {c.title}
            </a>
          ))}
        </div>

        {/* collection cards */}
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          {COLLECTIONS.map((c) => (
            <article
              key={c.id}
              id={`col-${c.id}`}
              className="group flex scroll-mt-24 flex-col rounded-xl border border-background-200 bg-background-50 p-5 md:p-6 transition-colors hover:border-primary-200"
            >
              <div className="flex items-start justify-between">
                <span className="serif-num -mb-2 text-5xl font-black leading-none text-background-300 transition-colors group-hover:text-primary-200 md:text-6xl">
                  {c.index}
                </span>
                <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-50 px-3 py-1 text-xs text-secondary-800">
                  <i className="ri-links-line text-sm" />
                  {c.count}
                </span>
              </div>

              <div className="mt-3 flex items-baseline gap-3">
                <h3 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">{c.title}</h3>
                <span className="text-xs uppercase tracking-widest text-foreground-400">{c.en}</span>
              </div>
              <p className="mt-1.5 text-xs leading-5 text-foreground-600 md:text-sm">{c.desc}</p>

              <div className="mt-4 border-t border-background-200 pt-4">
                <div className="flex flex-wrap gap-2">
                  {c.links.map((l) => (
                    <button
                      key={l.name}
                      type="button"
                      className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 py-1.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
                    >
                      <span className="flex h-4 w-4 items-center justify-center text-foreground-400 group-hover:text-primary-400">
                        <i className="ri-link text-xs" />
                      </span>
                      {l.name}
                      <Badge badge={l.badge} />
                    </button>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}